import './SearchUserRow.sass';

import React, { FC, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'react-router5';

import { SearchUserRowProps } from '$core/Search/SearchUserRow/SearchUserRow.interface';
import { UnitName, UnitPhoto, Verified } from '$shared/components';
import { useTranslator, useUserInfo } from '$hooks';
import { Button } from '$uikit';
import { CHAT, PROFILE, RESOLVE } from '$shared/constants/pages';
import { followersActions, followersSelector } from '$store/followers';
import { statReachGoal } from '$utils';

export const SearchUserRow: FC<SearchUserRowProps> = (props) => {
  const {
    item: { objectId, cover, coverThumbnail },
  } = props;
  const t = useTranslator();
  const router = useRouter();
  const dispatch = useDispatch();
  const { following } = useSelector(followersSelector);

  const user = useUserInfo(objectId);

  const handleClick = useCallback(
    ({ target }) => {
      if (target.closest('.Button')) {
        return;
      }

      if (user.domain) {
        router.navigate(RESOLVE, { domain: user.domain });
      } else {
        router.navigate(PROFILE, { id: objectId });
      }
    },
    [objectId, user],
  );

  const handleFollow = useCallback(() => {
    dispatch(followersActions.follow(objectId));
    statReachGoal('follow_from_search');
  }, [objectId]);

  const handleGoToChat = useCallback(() => {
    router.navigate(CHAT, { peerId: objectId });
    statReachGoal('go_to_chat_from_search');
  }, [objectId]);

  return (
    <div className="SearchUserRow" onClick={handleClick}>
      {cover ? (
        <div
          className="SearchUserRow__cover"
          style={{
            backgroundImage: `url(${cover}), url(${coverThumbnail})`,
          }}
        />
      ) : (
        <div
          className="SearchUserRow__cover fake"
          style={{
            backgroundImage: `url(${user.photo})`,
          }}
        />
      )}
      <div className="SearchUserRow__content">
        <div className="SearchUserRow__photo">
          <UnitPhoto unit={user} />
        </div>
        <div className="SearchUserRow__info">
          <div className="SearchUserRow__name__wrap">
            <div className="SearchUserRow__name">
              <UnitName unit={user} />
            </div>
            <Verified objectId={objectId} />
          </div>
          <div className="SearchUserRow__followers">
            {t('followed_count', { count: user.followers })}
          </div>
        </div>
        <div className="SearchUserRow__action">
          {following[objectId] ? (
            <Button mode="secondary" size="small" onClick={handleGoToChat}>
              {t('write_message_button')}
            </Button>
          ) : (
            <Button mode="light" size="small" onClick={handleFollow}>
              {t('follow_button')}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
